import React, { useState } from "react";
import { Segment } from "semantic-ui-react";
import { SearchAddPage } from "./SearchAddPage";
import type { WizardSupplyUnit, ProductData } from "./types";

interface AddSupplyUnitWizardProps {
  supplyUnits: WizardSupplyUnit[];
  setSupplyUnits: React.Dispatch<React.SetStateAction<WizardSupplyUnit[]>>;
  setAddingSupplyUnit: (value: boolean) => void;
  product: ProductData;
  preselectedSupplyUnits?: WizardSupplyUnit[];
}

export const AddSupplyUnitWizard = ({
  supplyUnits,
  setSupplyUnits,
  setAddingSupplyUnit,
  product,
}: AddSupplyUnitWizardProps) => {
  const [page] = useState(1);
  const [wizardSupplyUnits, setWizardSupplyUnits] = useState<WizardSupplyUnit[]>([]);

  const onSubmit = () => {
    setSupplyUnits((prev) => [...prev, ...wizardSupplyUnits]);
    setAddingSupplyUnit(false);
  };

  const renderPageContent = () => {
    switch (page) {
      case 1:
        return (
          <SearchAddPage
            onSubmit={onSubmit}
            masterSupplyUnits={supplyUnits}
            supplyUnits={wizardSupplyUnits}
            setSupplyUnits={setWizardSupplyUnits}
            product={product}
            onClose={() => setAddingSupplyUnit(false)}
          />
        );
      default:
        return null;
    }
  };

  return <Segment>{renderPageContent()}</Segment>;
};
